export default __webpack_public_path__ + "static/media/down.1a69e3aa24121071f40067ed448c3ec5.svg";